import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button, MenuSection, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchNaturalPersonById } from "../../api/naturalPersonService";
import NaturalPersonDetail from "./NaturalPersonDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { usePermissions } from "../../hooks/usePermissions";
import { usePersonAuthorityLink } from "../../hooks/usePersonAuthorityLink";
import { PersonAuthorityLinkMenuItems, PersonAuthorityLinkModals, } from "../../components/PersonAuthorityLinkActions";
var NaturalPersonDetailPage = function () {
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var canEditNaturalPerson = usePermissions().canEditNaturalPerson;
    var _a = useQuery(["naturalPerson", id], function () { return fetchNaturalPersonById(ky, id); }, {
        enabled: !!id,
    }), naturalPerson = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    // Hooks must run before the early returns below; the hook tolerates a missing person.
    var authorityLink = usePersonAuthorityLink({
        kind: "natural",
        person: naturalPerson,
        // The hook already stores the returned person in this page's query cache.
        onUpdated: function () { },
        onMerged: function (target) {
            if (target === null || target === void 0 ? void 0 : target.id) {
                history.replace("/bragency/natural-persons/detail/".concat(target.id));
            }
        },
    });
    var handleBackToList = function () {
        history.goBack();
    };
    var handleEdit = function () {
        history.push("/bragency/natural-persons/edit/".concat(id));
    };
    var handleReportChange = function () {
        history.push("/bragency/natural-persons/report-change/".concat(id));
    };
    if (!id) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.natural-person.detail.pane.title",
                }) },
                React.createElement("p", null, formatMessage({
                    id: "ui-br-agency.natural-person.id.not.provided",
                })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.natural-person.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (isError || !naturalPerson) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.natural-person.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) ||
                    formatMessage({ id: "ui-br-agency.natural-person.not.found" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    var displayName = naturalPerson.firstName && naturalPerson.lastName
        ? "".concat(naturalPerson.firstName, " ").concat(naturalPerson.lastName)
        : naturalPerson.firstName ||
            naturalPerson.lastName ||
            formatMessage({ id: "ui-br-agency.natural-person.detail.pane.title" });
    var actionMenu = canEditNaturalPerson ||
        authorityLink.canManage ||
        authorityLink.canMergeDuplicates
        ? function (_a) {
            var onToggle = _a.onToggle;
            return (React.createElement(MenuSection, { id: "natural-person-actions" },
                canEditNaturalPerson && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            onToggle();
                            handleEdit();
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" })),
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            onToggle();
                            handleReportChange();
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.button.reportChange" })))),
                React.createElement(PersonAuthorityLinkMenuItems, { link: authorityLink, onToggle: onToggle })));
        }
        : undefined;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: displayName, firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })), actionMenu: actionMenu },
            React.createElement(PersonAuthorityLinkModals, { link: authorityLink }),
            React.createElement(NaturalPersonDetail, { naturalPerson: naturalPerson }))));
};
export default NaturalPersonDetailPage;
